/** JSX compatible HTML entity strings. */
export const HTML_ENTITIES = {
  copyright: String.fromCharCode(169)
};
